import { useAutoAnimate } from '@formkit/auto-animate/react';

import { EventMatching } from './event-matching';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type Props = {
  shares: string;
  setShares: (shares: string) => void;
  matchingAmount: number | null;
};

export const EventBuySharesInput = ({
  shares,
  setShares,
  matchingAmount,
}: Props) => {
  const [parent] = useAutoAnimate();

  const handleAddShares = (value: number) => {
    const sharesValue = isNaN(Number(shares)) ? 0 : Number(shares);

    if (sharesValue + value < 0.01) {
      setShares('');
      return;
    }

    setShares((sharesValue + value).toString());
  };

  const handleChangeShares = (value: string) => {
    if (value && !/^[0-9.,]+$/.test(value)) return;

    if (value.startsWith('.')) {
      value = '0' + value;
    }

    setShares(value.replace(',', '.'));
  };

  return (
    <>
      <div className="flex flex-row gap-[10px]">
        <div className="min-w-[160px] text-[14px] text-[#767676]">
          Shares to Purchase
        </div>
        <input
          className="h-[40px] w-full bg-transparent text-end text-[24px]"
          value={shares}
          type="number"
          placeholder="0"
          onChange={(e) => handleChangeShares(e.target.value)}
        />
      </div>
      <div
        className={cn(
          'flex w-full flex-row justify-between',
          matchingAmount === null ? 'justify-end' : 'justify-between',
        )}
      >
        {matchingAmount !== null && (
          <div ref={parent}>
            <EventMatching amount={matchingAmount} />
          </div>
        )}

        <div className="flex flex-row justify-end gap-[10px] text-[14px]">
          <Button
            onClick={() => handleAddShares(-10)}
            disabled={isNaN(+shares) || +shares === 0}
            size="medium"
            variant="accent"
          >
            -10
          </Button>
          <Button
            onClick={() => handleAddShares(10)}
            disabled={isNaN(+shares)}
            size="medium"
            variant="accent"
          >
            +10
          </Button>
        </div>
      </div>
    </>
  );
};
